<!--
	TaxonomyChips.svelte

    5/11/22 - new architecture for Taxonomies
-->

<script>
    import { onMount } from 'svelte';
	// import { selectedChipNodesArray } from '../../stores/SearchStores';
	// import { updateTaxonomyTree, updateSelectedChipNodesArray } from '../../stores/SearchStores';

    // TCARE components
    import SearchChip from '../searches/SearchChip.svelte';

    // 5/11 - NEW ARCHITECTURE
    export let store;                                               // Search or Service master object
    export let taxName;
    
    $: taxonomy = $store.taxonomies[taxName] || null;
    $: selectedNodes = taxonomy ? taxonomy.getSelectedNodes() : [];
    
    onMount(() => {
        // console.log('');
        // console.log('SearchChips onMount');
        // console.log('$store:');
        // console.log($store);
    })

    // always deselects the node
    const onChipClick = (selectedNode) => {
        selectedNode.isSelected = false;
        $store = $store;                                          // MUST RESET THE STORE TO TRIGGER UI!
    }

</script>


<style>

    /* min-height so the tree does not move until after two rows filled */
    .search-chips {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        align-items: flex-start;
        justify-content: flex-start;
        min-height: 28px;       /* one row */
        /* border: 1px solid red; */
    }

    @media screen and (max-width: 600px) {
    }

    @media screen and (min-width: 601px) and (max-width: 1300px) {
    }

    @media screen and (min-width: 1201px) {
    }

</style>

<div class="search-chips">    
    {#if store}
        
        {#each selectedNodes as selectedNode}
            <SearchChip {selectedNode} {onChipClick} />            
        {/each}
        
    {/if}
</div>
